export default __webpack_public_path__ + "static/media/3.99ba1cbf.png";